import type { FaireProductEntity } from "../../entity_types/product";

export const p_54cafrksms: FaireProductEntity = {
  token: "p_54cafrksms",
  type: "product",
  name: "Witch Hazel",
  brandToken: "b_9p9pjx33",
  brandName: "Simply Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/a5f0e214ca2b2eab9328231e8c88a4e0a23fcca70d6f81dda4f09ce972f45b1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d86ac35f9a3cf1ffef4a540a607aa808a5205767c9edbfaaef991e9ea7de0ec.jpeg",
    "https://cdn.faire.com/fastly/69acb57bd3702754f2c8751c89f7afa4c7a6a9892e40e410ecd619300fe347d4.jpeg",
  ],
  priceDollars: 4.54,
  description:
    "Witch Hazel: Your New Favorite All-Natural Astringent!\n\n- Eases irritation and inflammation\n- Natural astringent\n- Alcohol free\n\nWhat is Witch Hazel?\nWitch Hazel serves as an alcohol- and sting-free ingredient. It can balance oil on the skin, care for your scalp, add moisture to your bath bombs, or calm insect bites. You'll love adding witch hazel to your daily routine!\n\nIngredient: Hamamelis Virginiana\n\nHow do I use Witch Hazel?\nUse this ingredient in your facial toner, cleanser, and room spray recipes. \n\nWhat else should I know about Witch Hazel?\nFor external use only. Keep out of reach of children. Avoid contact with eyes. If irritation, redness, or discomfort occurs, discontinue use.",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:56.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
